"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = !0;
exports.default = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledSystem = require("styled-system");

var _tokens = _interopRequireDefault(require("../../Tokens/tokens"));

var colors = _tokens.default.colors;

var TickCircleSvg = function TickCircleSvg(_ref) {
  var className = _ref.className,
      width = _ref.width,
      height = _ref.height;
  return /*#__PURE__*/_react.default.createElement("svg", {
    className: className,
    width: width,
    height: height,
    viewBox: "0 0 18 18",
    focusable: "false",
    "aria-hidden": "true"
  }, /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("path", {
    d: "M16 7.273A8.727 8.727 0 007.273 16 8.727 8.727 0 0016 24.727 8.727 8.727 0 0024.727 16 8.727 8.727 0 0016 7.273zM14.97 20.23l-3.221-3.219 1.23-1.234 1.957 1.95 5.022-5.308 1.268 1.2-6.256 6.61z",
    id: "a"
  })), /*#__PURE__*/_react.default.createElement("g", {
    transform: "translate(-7 -7)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/_react.default.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/_react.default.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/_react.default.createElement("use", {
    fill: "#000",
    fillRule: "nonzero",
    xlinkHref: "#a"
  }), /*#__PURE__*/_react.default.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fill: colors.aquamentus,
    d: "M1.455 1.455h29.09v29.09H1.456z"
  }))));
};

var TickCircle = (0, _styledComponents.default)(TickCircleSvg).withConfig({
  displayName: "TickCircle",
  componentId: "sc-183ntjr-0"
})(["", ""], _styledSystem.layout);
TickCircle.defaultProps = {
  height: 24,
  width: 24
};
TickCircle.propTypes = {
  className: _propTypes.default.string,
  width: _propTypes.default.number,
  height: _propTypes.default.number
};
var _default = TickCircle;
exports.default = _default;